// @flow

const paymentProviders = {
    /* eslint-disable sort-keys */
    SQUARE: 1,
    STRIPE: 2,
    PAYRIX: 3,
    /* eslint-enable sort-keys */
};

export default paymentProviders;
